"use strict";
import React from "react";

const ValidatorTypes = {
    Required: 'required',
    Regex: 'regex'
}

const RegexTypes = {
    Email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
    Name: /^[a-z ,.'-]+$/i,
    Phone: /[+()-\s\. 0-9]+/
}

class ValidatedForm extends React.Component {

    constructor(props) {
        super(props);
    }

    validateComponent(component) {
        let validators = component.validators;
        let valid = true;

        if (validators) {
            for (var i = 0; i < validators.length; i++) {
                switch (validators[i].type) {
                    case ValidatorTypes.Required:
                        valid = valid && component.value && component.value !== '';
                        break;

                    case ValidatorTypes.Regex:
                        let isValid = component.validators[i].value.test(component.value);;

                        if (!isValid && component.validators[i].allowNullOrUndefined) {
                            isValid = !component.value;
                        }

                        valid = valid && isValid;
                        break;
                }
            }
        }

        return valid;
    }

    handleChange(e) {
        let target = e.target;
        let form = this.state.form;
        let component = form[target.name];

        component.value = target.value;
        form[target.name] = component;

        this.handleValidation(target.name, this.validateComponent(component));
        this.setState({form: form});
    }

    handleValidation(name, valid) {
        let form = this.state.form;
        let component = form[name];
        component.valid = valid;
        form[name] = component;

        this.setState({form: form});
    }

    validateForm(components, handleComponentValidation, handleSubmitForm, e) {
        e.preventDefault();
        let validForm = true;

        for (var component in components) {
            let componentValid = this.validateComponent(components[component]);
            validForm = validForm && componentValid;
            handleComponentValidation(component, componentValid);
        }

        if (validForm) {
            handleSubmitForm();
        }
    }
}

ValidatedForm.ValidatorTypes = ValidatorTypes;
ValidatedForm.RegexTypes = RegexTypes;

module.exports = ValidatedForm;